import { blue, grey, orange, red } from "@mui/material/colors";

const styles = {
  dialog: {
    borderRadius: "16px",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
    marginBottom: 5,
  },
  subtitle: {
    textAlign: "center",
    color: grey[800],
    marginBottom: 16,
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    padding: 0,
    marginTop: 36,
    gap: 12,
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  circularProgress: {
    color: 'white',
  },
  activeButton: {
    width: '160px',
    borderRadius: '0.5rem',
    height: '38px',
    backgroundColor: red['A400'],
    color: 'white',
    '&:hover': {
      backgroundColor: red['A700'],
    },
  },
  mainContainer: {
    padding: 30,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  alert: {
    margin: '20px 0px',
    width: '50%',
  },
  resumeContainer: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'spaceBetween',
  },
  resumeQuantity: {
    fontWeight: 'bold',
    textAlign: 'center'
  },
  resumeSubtitle: {
    textAlign: "center",
  },
  resumeCountErrorContainer: {
    color: red[600],
    backgroundColor: red[100],
    borderRadius: '8px',
    padding: '10px 0px',
  },
  resumeCountInfoContainer: {
    color: blue[600],
    backgroundColor: blue[100],
    borderRadius: '8px',
    padding: '10px 0px',
  },
  resumeCountAlertContainer: {
    color: orange[600],
    backgroundColor: orange[100],
    borderRadius: '8px',
    padding: '10px 0px',
  },
  resumeCountSuccessContainer: {
    color: "#53CA99",
    backgroundColor: "#D1F0F2",
    borderRadius: '8px',
    padding: '10px 0px',
  }
};

export default styles;
